import { render, staticRenderFns } from "./LeadEditForm.vue?vue&type=template&id=030886a6&scoped=true"
import script from "./LeadEditForm.vue?vue&type=script&lang=js"
export * from "./LeadEditForm.vue?vue&type=script&lang=js"
import style0 from "./LeadEditForm.vue?vue&type=style&index=0&id=030886a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030886a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
